export class CalendarHelper {
	public readonly appointmentLength = {
		minValue: 0,
		maxValue: 999
	};
}

export const calendarHelper = new CalendarHelper();
